import { SummaryReport } from 'schemas/SummaryReport.schema.ts';
import { Iteration } from 'schemas/Iteration.schema.ts';
import { getIsCurrentSummaryReport } from 'utils/summaryReports.ts';

interface IReviewerMessageProps {
  report: SummaryReport,
  iteration: Iteration,
}

function ReviewerMessage({ report, iteration }: IReviewerMessageProps) {
  const isCurrentSummaryReport = getIsCurrentSummaryReport(
    report,
    iteration,
  );

  const reviewer = report.summary_report_review?.reviewer;

  if (reviewer) {
    if (reviewer.given_name && reviewer.family_name) {
      return `${reviewer.given_name} ${reviewer.family_name}`;
    }

    return reviewer.email;
  }

  if (isCurrentSummaryReport) {
    return 'Awaiting reviewer';
  }

  return 'Not reviewed';
}

export default ReviewerMessage;
